<template>
  <div class="manhole-content" v-loading="loading">
    <el-button
      type="primary"
      class="mw-add-button"
      @click="openEditWin('create')"
      >添加</el-button
    >
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="id" label="ID" width="100"> </el-table-column>
      <el-table-column prop="title" label="设备名称"> </el-table-column>
      <el-table-column prop="deviceId" label="设备id"> </el-table-column>
      <el-table-column prop="imei" label="IMEI"> </el-table-column>
      <el-table-column prop="imsi" label="IMSI" width="180"> </el-table-column>
      <el-table-column prop="power" label="剩余电量" width="140">
      </el-table-column>
      <el-table-column prop="temp" label="温度"> </el-table-column>
      <el-table-column prop="water" label="水位" sortable>
        <template slot-scope="scope">
          <i :class="steClassName(scope.row.water)"></i>
          <span>{{ steWaterValue(scope.row.water) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="online" label="网络在线状态" sortable>
        <template slot-scope="scope">
          <i :class="onlineClassName(scope.row.online)"></i>
          <span>{{ onlineValue(scope.row.online) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="设备设防状态" prop="she" sortable>
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.she"
            :active-value="1"
            :inactive-value="0"
            active-color="#67C23A"
            inactive-color="#aaaaaa"
            @change="changeSwitch(scope.row.id, scope.row.she)"
          />
        </template>
      </el-table-column>

      <el-table-column prop="ste" label="设备实际状态" sortable>
        <template slot-scope="scope">
          <i :class="steClassName(scope.row.ste)"></i>
          <span>{{ steValue(scope.row.ste) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="edit" label="编辑" width="100">
        <template slot-scope="scope">
          <div class="edit-button">
            <i
              @click="openEditWin(scope.row)"
              class="el-icon-edit pointer mar-r10"
            ></i>
            <i
              class="el-icon-delete pointer"
              @click="delItem(scope.row.id)"
            ></i>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageInfo.page"
      :page-sizes="[10, 20, 30, 40, 50, 100]"
      :page-size="pageInfo.pageSize"
      layout="sizes, total, prev, pager, next, jumper"
      :total="cnt_all"
    >
    </el-pagination>

    <!--新增对话框-->
    <el-dialog
      custom-class="mw-edit-dialog"
      class="dialog600"
      :title="editType === 'create' ? '添加井盖设备' : '修改井盖设备'"
      :visible.sync="dialogVisible"
      v-if="dialogVisible"
    >
      <el-form
        :model="editOne"
        label-position="left"
        label-width="100px"
        :rules="editOneRule"
      >
        <div class="user-info">
          <el-form-item label="设备名称" prop="title">
            <el-input v-model="editOne.title"></el-input>
          </el-form-item>
		  <el-form-item label="设备ID" prop="title">
            <el-input v-model="editOne.device_id"></el-input>
          </el-form-item>
          <el-form-item label="IMSI" prop="imsi">
            <el-input v-model="editOne.imsi"></el-input>
          </el-form-item>
          <el-form-item label="IMEI" prop="imei">
            <el-input v-model="editOne.imei"></el-input>
          </el-form-item>

          <div class="map-container">
            <el-amap
              ref="map"
              vid="amap"
              :center="myMap.center"
              :zoom="myMap.zoom"
              :plugin="myMap.plugin"
              class="amap-demo"
              mapStyle="amap://styles/light"
              :events="myMap.events"
            >
              <el-amap-circle-marker
                :center="myMap.markercenter"
                :radius="myMap.radius"
                fillColor="gray"
                strokeColor="#fff"
                :fillOpacity="myMap.fillOpacity"
              >
              </el-amap-circle-marker>
            </el-amap>
          </div>
          <el-form-item label="经度" prop="lng">
            <el-input v-model="editOne.lng" disabled></el-input>
          </el-form-item>
          <el-form-item label="纬度" prop="lat">
            <el-input v-model="editOne.lat" disabled></el-input>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="mw-edit-button" @click="dialogVisible = false"
          >取消</el-button
        >
        <el-button
          type="primary"
          @click="createItem"
          v-if="editType === 'create'"
          >确 定</el-button
        >
        <el-button
          type="primary"
          @click="updateItem"
          v-if="editType === 'update'"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import manholeListApi from "@/api/manhole/manholeList";
import store from '@/store'
export default {
  data() {
    const vm = this;
    return {
      myMap: {
        center: store.state.user.account.center,
        markercenter: [0, 0],
        events: {
          mapmove: () => {
            this.handleMove();
          },
        },
        plugin: [
          {
            pName: "Geolocation",
            enableHighAccuracy: true,
            timeout: 1000,
            showMarker: false,
            showButton: false,
            showCircle: false,
            panToLocation: false,
            zoomToAccuracy: false,
            events: {
              init(o) {
                o.getCurrentPosition((status, result) => {
                  // console.log(status)
                  // console.log(result)
                  if (status === "error") {
                    alert("获取定位失败，请移动地图定位位置");
                  } else {
                    //   console.log('result', result)
                    vm.myMap.center = [
                      result.position.lng,
                      result.position.lat,
                    ];
                    vm.myMap.markercenter = [
                      result.position.lng,
                      result.position.lat,
                    ];
                  }
                });
              },
            },
          },
        ],
        zoom: 12,
        radius: 10,
        fillOpacity: 1,
      },
      loading: false,
      dialogVisible: false,
      tableData: [],
      pageInfo: {
        page: 1,
        pageSize: 20,
      },
      cnt_all: 0,
      editOneRule: {
        name: [{ required: true, message: "请输路名称", trigger: "blur" }],
        device_id: [
          { required: true, message: "请输入设备id", trigger: "blur" },
        ],
        imsi: [{ required: true, message: "请输入imsi号", trigger: "blur" }],
        imei: [{ required: true, message: "请输入imei号", trigger: "blur" }],
        lng: [{ required: true, message: "请输入经度", trigger: "blur" }],
        lat: [{ required: true, message: "请输入lat", trigger: "blur" }],
      },
      editType: -1,
      devSelect: [],
      editOne: {},
    };
  },
  methods: {
    getTableData(pageIndex) {
      this.pageInfo.page = pageIndex;
      this.loading = true;
      manholeListApi.manholeList(this.pageInfo).then((res) => {
        if (res.data.code === 1000) {
          this.loading = false;
          let resData = res.data.data;
          this.tableData = resData.list;
          this.pageInfo.page = pageIndex;
          this.cnt_all = parseInt(resData.count);
        }
      });
    },

    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getTableData(this.pageInfo.page);
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val;
      this.getTableData(this.pageInfo.page);
    },

    openEditWin(index) {
      if (index === "create") {
        this.editOne = {
          title: "",
          device_id: "",
          imsi: "",
          imei: "",
          lng: "",
          lat: ""
        };
        this.editType = "create";
      } else { 
		    this.editOne = {
          id: index.id,
          title: index.title,
          device_id: index.deviceId,
          imsi: index.imsi,
          imei: index.imei,
          lng: index.lng,
          lat: index.lat
        };
        if (index.lng !== "0" && index.lat !== "0") {
          this.myMap.center = [index.lng, index.lat];
          this.myMap.markercenter = [index.lng, index.lat];
          this.myMap.plugin = []
        }
        this.editType = "update";
      }
      this.dialogVisible = true;
    },

    updateItem() {
      manholeListApi.manholeEdit(this.editOne.id, this.editOne).then((res) => {
        if (res.data.code === 1000) {
          this.dialogVisible = false;
          this.$message.success("修改成功");

          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    createItem() {
      manholeListApi.manholeAdd(this.editOne).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success("添加成功");
          this.dialogVisible = false;
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    delItem(id) {
      this.$confirm("本操作将永久删除该条信息，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          manholeListApi.manholeDel(id).then((res) => {
            if (res.data.code === 1000) {
              this.$message.success("删除成功");
              this.getTableData(this.pageInfo.page);
            } else {
              this.$message.error(res.data.message);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    changeSwitch(id, ste) {
      manholeListApi.manholeSet(id,{ type: ste }).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success("设置成功");
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    onlineClassName(ste) {
      if (ste === "1") {
        return "valuegreen";
      } else {
        return "valuered";
      }
    },
    onlineValue(num) {
      if (num === "1") {
        return "在线";
      } else {
        return "离线";
      }
    },

    sheClassName(ste) {
      if (ste === "1") {
        return "valuegreen";
      } else {
        return "valueyellow";
      }
    },
    sheValue(num) {
      if (num === "1") {
        return "已设防";
      } else {
        return "未设防";
      }
    },

    steClassName(ste) {
      switch (parseInt(ste)) {
        case 0:
          return "valuegreen";
          break;
        case 1:
          return "valuered";
          break;
        case 2:
          return "valuered";
          break;
        case 3:
          return "valuegreen";
          break;
      }
    },
    steValue(num) {
      switch (parseInt(num)) {
        case 0:
          return "正常";
          break;
        case 1:
          return "打开";
          break;
        case 2:
          return "松动";
          break;
        case 3:
          return "正常";
          break;
      }
    },
    steWaterValue(num) {
      switch (parseInt(num)) {
        case 0:
          return "正常";
          break;
        case 1:
          return "水满";
          break;
        case 2:
          return "中水位";
          break;
        case 3:
          return "低水位";
          break;
      }
    },
    handleMove() {
      this.myMap.markercenter = this.$refs.map.$$getCenter();
      this.editOne.lng = this.myMap.markercenter[0];
      this.editOne.lat = this.myMap.markercenter[1];
    },
  },
  mounted() {
    this.getTableData(this.pageInfo.page);
  },
};
</script>
<style lang='less' scoped>
.manhole-content {
  width: 100%;

  .valuegreen {
    display: inline-block;
    width: 10px;
    height: 10px;
    background: rgba(26, 151, 14, 0.856);
    border-radius: 50%;
    border: 1px solid rgba(26, 151, 14, 0.856);
    margin-right: 5px;
  }
  .valuered {
    display: inline-block;
    width: 10px;
    height: 10px;
    background: rgba(241, 12, 4, 0.856);
    border-radius: 50%;
    border: 1px solid rgba(241, 12, 4, 0.856);
    margin-right: 5px;
  }
  .valueyellow {
    display: inline-block;
    width: 10px;
    height: 10px;
    background: #d0a702;
    border-radius: 50%;
    border: 1px solid #d0a702;
    margin-right: 5px;
  }

  .map-container {
    padding-left: 100px;
    height: 320px;
    margin-bottom: 10px;
  }
}
</style>